module.exports = __webpack_public_path__ + "static/media/dadcard2.30a5dbe2.gif";